import { css } from 'lit';

export const stepContainerStyles = css`
  .step-container {
    min-height: 200px;
    border-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px;
  }
  .file-name {
    font-size: 1rem;
    line-height: 1.125rem;
    font-weight: 700;
  }
`;
